<template>
  <el-dialog title='船舶信息' :visible.sync='dialogTableVisible'
             :close-on-click-modal='false'>
    <el-table :data='tableData' border v-loading='loading'>
      <el-table-column property='startPortName' label='起始港' align='center' show-overflow-tooltip />
      <el-table-column property='endPortName' label='交车港' align='center' show-overflow-tooltip />
      <el-table-column property='carNumber' label='数量' align='center' show-overflow-tooltip />
    </el-table>
  </el-dialog>
</template>

<script>
  import { getShipInfo } from '@/service/vehiclelog';

  export default {
    name: 'info',
    data() {
      return {
        dialogTableVisible: false,
        tableData: [],
        loading: false,
      };
    },
    methods: {
      async openDialog(id) {
        this.dialogTableVisible = true;
        this.loading = true;
        const {
          status,
          message,
          data,
        } = await getShipInfo(id);
        this.loading = false;
        if (status !== 0) this.$message.warning(message);
        this.tableData = data;
      },
    },
  };
</script>

<style lang='scss' scoped>
  ::v-deep {
    .el-dialog__body {
      padding: 20px !important;
    }
  }
</style>
